var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerMessage",style:({ 'background-color': 'none' })},[_c('ul',{staticClass:"ulMessageMenu"},_vm._l((_vm.getObjectMenu(_vm.message.message)),function(item,index){return _c('li',{key:index,staticClass:"liMessageMenu",class:_vm.optionClicked
          ? 'changeCursor ' +
            (index + 1 !== _vm.optionClicked ? 'notselected' : 'selected')
          : 'selected',style:({
        'border-color': _vm.getWebchat().campaign.color,
        color: _vm.invertColor(_vm.getWebchat().campaign.color, true, true),
      }),on:{"click":function($event){return _vm.sendMessage(item.option, index)}}},[_c('span',{staticStyle:{"float":"left","position":"absolute","top":"6px"}},[_c('v-icon',{style:({
            color: _vm.invertColor(_vm.getWebchat().campaign.color, true, true),
          })},[_vm._v(" mdi-chevron-right ")])],1),_vm._l((item.optionName),function(e){return _c('div',{key:e.optionName,staticClass:"pMessageMenu",class:_vm.optionClicked ? 'changeCursor' : '',style:({
          color: _vm.invertColor(_vm.getWebchat().campaign.color, true, true),
          'font-size': '14px',
        })},[_c('a',{class:_vm.optionClicked ? 'changeCursor' : '',style:({
            color: _vm.invertColor(_vm.getWebchat().campaign.color, true, true),
            'font-size': '14px',
          }),domProps:{"innerHTML":_vm._s(_vm.styleMessage(e))}})])})],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }